import { take, put } from 'redux-saga/effects';
import { REGISTER_USER_FAILURE, REGISTER_USER_SUCCESS } from 'redux/actions';
import { actions } from 'react-redux-form';

export function* registerUserFinalSaga() {
  yield take([REGISTER_USER_SUCCESS, REGISTER_USER_FAILURE]);
  yield put(actions.setPending('entities.forms.user', false));
}
